export default {
  xeroRepeatingInvoices: [],
  xeroRepeatingInvoice: undefined,
};
